import { Business } from "@/types/BusinessInterface";
import { LotInterface } from "@/types/LotInterface";

export function getBusinessNameFromLot(
  lot: LotInterface | null,
  businesses: Business[]
): string {
  if (!lot) return "-";

  if (lot.ownershipId && typeof lot.ownershipId === "object") {
    return (lot.ownershipId as Business).name ?? "-";
  }

  if (lot.ownershipId && typeof lot.ownershipId === "string") {
    const matchedBusiness = businesses.find(
      (business) => business._id === lot.ownershipId
    );

    return matchedBusiness?.name ?? "-";
  }

  return "-";
}
